"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A simple class very similar to a map or a plain object that acts as an indexed container for a group of values
 *
 * @class
 */
var PropertyBag =
/**
 * @param {...*} props
 */
function PropertyBag(_ref) {
  var _this = this;

  var props = (0, _objectWithoutProperties3.default)(_ref, []);
  (0, _classCallCheck3.default)(this, PropertyBag);

  this.getProperty = function (propName) {
    if (_this.props.hasOwnProperty(propName)) {
      return _this.props[propName];
    }

    return undefined;
  };

  this.toJSON = function () {
    return _this.toJS();
  };

  this.toJS = function () {
    return JSON.parse((0, _stringify2.default)(_this.props));
  };

  this.props = (0, _extends3.default)({}, props);
}

/**
 * Returns a value from the bag
 *
 * @method
 *
 * @param {String} propName
 * @return {*}
 */


/**
 * Alias for `toJS`
 *
 * @method
 * @return {Object}
 */


/**
 * Returns a deep clone of this object
 *
 * @method
 * @return {Object}
 */
;

exports.default = PropertyBag;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/PropertyBag.js
// module id = 42
// module chunks = 0